export const getServiceProvidedOption = (serviceOption, serviceProvided) => {
  return serviceOption.filter(patrolService =>
    serviceProvided.includes(patrolService.id),
  );
};

export const getGlobalDepartments = (globalDepartments = {}) => {
  const transformedDepartments = globalDepartments
    ? Object.keys(globalDepartments).map(key => ({
        id: key,
        name: globalDepartments[key],
      }))
    : [];
  return transformedDepartments;
};
